import { render, staticRenderFns } from "./production-calendar.vue?vue&type=template&id=50b1c7aa"
import script from "./production-calendar.vue?vue&type=script&lang=js"
export * from "./production-calendar.vue?vue&type=script&lang=js"
import style0 from "./production-calendar.vue?vue&type=style&index=0&id=50b1c7aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports